// extracted by mini-css-extract-plugin
export var wrapper = "toggle-module--wrapper--cOG63";
export var content = "toggle-module--content--pyxHv";
export var toggle = "toggle-module--toggle--Flspg";
export var names = "toggle-module--names--PFlzh";
export var checkboxToggle = "toggle-module--checkboxToggle--GecjL";
export var dance = "toggle-module--dance--kk8Gs";
export var fitness = "toggle-module--fitness--ytDqr";